import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
import { rem } from 'polished';
import {
  FlexCol,
  FlexColCenterVertical,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __, __r } from 'react-i18n';
import { TextP } from '../../..';

interface Props {
  title: string;
  content: any;
  url?: string;
}

function DashboardColumn(props) {
  const { title, content, url } = props;
  const contentLength = content.length;
  return (
    <Wrapper>
      <Title>{title}</Title>
      <ContentWrapper>
        <Items contentLength={contentLength}>
          {content.map((item, key) => (
            <ContentItem key={key} index={key}>
              <ItemName>{`${item.name}`}</ItemName>
              <ItemNumber>{`${item.number} €`}</ItemNumber>
            </ContentItem>
          ))}
        </Items>
        {contentLength < 3 && (
          <BottomWrapper>
            <StyledLink
              to={__r(`routes:${url}`, `/${url}`)}
            >{`Zobraziť viac`}</StyledLink>
          </BottomWrapper>
        )}
      </ContentWrapper>
    </Wrapper>
  );
}

const Title = styled.h3`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${rem(20)};
  font-weight: 500;
  margin-bottom: ${rem(24)};
`;

const Wrapper = styled(FlexCol)`
  width: 100%;
  max-width: ${rem(254)};
  margin-right: ${rem(16)};
`;

const ContentWrapper = styled(FlexColCenterVertical)`
  width: 100%;
  padding: ${rem(24)};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
`;

const Items = styled.div<{ contentLength: number }>`
  height: ${({ contentLength }) => (contentLength < 2 ? rem(137) : 'initial')};
`;

const ContentItem = styled(FlexColCenterVertical)<{ index: number }>`
  margin-bottom: ${({ index }) => (index === 2 ? 0 : rem(24))};
`;

const ItemName = styled(TextP)`
  font-size: ${rem(14)};
  color: #aaaaaa;
  margin-bottom: ${rem(4)};
`;

const ItemNumber = styled(TextP)`
  font-size: ${rem(20)};
  font-weight: 500;
`;

const BottomWrapper = styled(FlexRowCenterVertical)`
  padding-top: ${rem(24)};
  border-top: 1px solid #eeeeee;
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
`;

export { DashboardColumn as DsiDashboardColumn };
